import axios from "axios";
import { apiFetch } from "./apiFetch";
import { handleApiError, getErrorMessage } from "./errorHandler";

let cache = new Map();
let inFlight = new Map();
const CACHE_DURATION = 3000; // 3s

// CONSULTAR MENSAGENS
export const getMessages = async (
  chatstp,
  limit = 20,
  before = null
) => {
  try {
    if (!chatstp) throw new Error("chatstp não fornecido");

    const key = `${chatstp}|${limit}|${before || "null"}`;
    const now = Date.now();

    // Retorna cache se ainda está válido
    if (cache.has(key)) {
      const cached = cache.get(key);
      if (now - cached.time < CACHE_DURATION) {
        return cached.data;
      }
    }


    if (inFlight.has(key)) {
      return inFlight.get(key);
    }

    let url = `/messenger/chats/${chatstp}/messages?limit=${limit}`;

    if (before) {
      url += `&before=${encodeURIComponent(before)}`;
    }

    const promise = (async () => {
      try {
        const response = await apiFetch(url);

        if (!response.ok) {
          const errorMsg = getErrorMessage(response);
          throw new Error(errorMsg);
        }

        const data = await response.json();
        
        cache.set(key, {
          data,
          time: Date.now(),
        });

        return data;
      } finally {
        inFlight.delete(key);
      }
    })();

    inFlight.set(key, promise);
    return promise;

  } catch (error) {
    const handled = handleApiError(error, "getMessages");
    throw handled;
  }
};




// ENVIAR FICHEIRO (UPLOAD HTTP)
export const sendFileMessage = async ({
  token,
  chatstp,
  file,
  tipo,
  onProgress
}) => {
  try {
    if (!token) throw new Error("Token não fornecido");
    if (!chatstp) throw new Error("chatstp não fornecido");
    if (!file) throw new Error("Ficheiro não fornecido");

    const formData = new FormData();
    formData.append("file", file);
    formData.append("TIPO", tipo);
    formData.append("MENSAGEM", "");

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/messenger/chats/${chatstp}/messages`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        onUploadProgress: (event) => {
          if (onProgress && event.total) {
            const percent = Math.round((event.loaded * 100) / event.total);
            onProgress(percent);
          }
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      throw new Error("Sessão expirada. Faça login novamente.");
    }
    throw error;
  }
};
